import { ApolloLink } from "./ApolloLink.js";

export const empty = ApolloLink.empty;
